/*
 * Copyright 2019 FedEx
 */
export class FileUploadObjectModel {
    fileToUpload: File;
    reasonCode: string;

    public constructor(reasonCode_c: string, fileToUpload_c: File) {
        this.fileToUpload = fileToUpload_c;
        this.reasonCode = reasonCode_c;
    }
}
